<template>
	<div class="box">
		<div class="box-header">
			<h2 class="box-title" v-if="profile.id">Editing Ferment Profile</h2>
			<h2 class="box-title" v-else>New Ferment Profile</h2>
		</div>
		<div class="box-body">

			<p>
				Ferment profiles provide a rough temperature map for the simulator to follow. You don't have to use them, but outlining a temperature pathway will improve the prediction. Remember, the simulator will assume that the ferment will remain at the last temperature seen unless you tell it otherwise.
			</p>

			<form class="form-horizontal">
				<fieldset>
					<input-text name="name" :vmodel.sync="profile.name" label="Profile Name"></input-text>

					<input-text name="duration" :vmodel.sync="profile.duration" label="Desired Duration" :spinner="true" postfix="Days"></input-text>

					<div class="col-md-6">
						<input-toggle
							name="type"
							:vmodel.sync="profile.type"
							on="Red"
							off="White"
							label="Profile Type">
						</input-toggle>
					</div>
				</fieldset>

				<daily-data v-if="measuringFreqInteger"
					:daily-data.sync="profile.dailyData"
					:measuring-freq-integer="measuringFreqInteger"
					:ferment-type="profile.type">
				</daily-data>

				<div class="alert alert-warning" v-if="profile.dailyData && ! profile.name" style="margin: 20px 0 0">
					<i class="fa fa-exclamation-triangle"></i> Please note that all daily data will remain unsaved until you give this profile a name.
				</div>
			</form>

			<div class="margin-20"></div>

			<a v-if="profile.id" @click="delete" class="btn btn-danger"><i class="fa fa-close"></i> Delete Profile</a>
		</div>
	</div>
</template>

<script>
	import { Profiles as ProfileActions } from 'vx/actions'
	import { site, simulatorSetup as simulator } from 'vx/getters'
	import Notify from 'utils/notify'
	import Alert from 'utils/alert'
	import DailyData from 'components/ferment/daily-data'

	export default {
		components: {
			DailyData
		},

		data() {
			return {
				timeouts: {
					profile: null,
					dailyData: null
				},
				oldProfile: {}
			};
		},

		vuex: {
			actions: {
				all: ProfileActions.all,
				store: ProfileActions.store,
				update: ProfileActions.update,
				edit: ProfileActions.edit,
				destroy: ProfileActions.destroy,
				clear: ProfileActions.clear
			},
			getters: {
				site,
				simulator
			}
		},

		computed: {
			measuringFreqInteger() {
				if (this.simulator) {
					return this.profile.type ? this.simulator.red_sampling_freq : this.simulator.white_sampling_freq
				}

				return null
			}
		},

		props: ['profile'],

		ready() {},

		watch: {
			profile: {
				handler: 'handleProfileChanges',
				deep: true
			}
		},

		methods: {
			handleProfileChanges(value, old) {
				if (this.profile.name == undefined || this.profile.name == '' || value.id != old.id) {
					return;
				}

				clearTimeout(this.timeouts.profile);

				this.timeouts.profile = setTimeout(() => {
					this.saveOrCreate();
				}, 1250);
			},

			saveOrCreate() {
				if (this.profile.id == null) {
					this.create();
				} else {
					this.save();
				}
			},

			create() {
				return this.store(this.site.id, this.profile).then(response => {
					Notify.success('New ferment profile added.');
				});
			},

			save() {
				return this.update(this.site.id, this.profile).then(response => {
					this.all(this.site.id);

					Notify.success('Ferment profile updated.');
				});
			},

			delete() {
				let self = this;

				Alert.delete({
					showLoaderOnConfirm: true,
					preConfirm() {
						return self.destroy(self.site.id, self.profile.id);
					}
				}).then(() => {
					this.clear();

					this.all(this.site.id);

					Alert.success({ text: 'Profile has been deleted.' }).then(() => {}, () => {});
				}, () => {});
			}
		}
	}
</script>



// WEBPACK FOOTER //
// profile-form.vue?abc22ca4